export default {
  menus: {
    // 公共
    index: 'Index',
    // 一级
    workplace: 'Work Place',
    content: 'Content Manage',
    column: 'column Manage',
    config: 'Config',
    statistics: 'Website Statistics',
    interact: 'Interact',
    social: 'Social Media',
    vip: 'VIP',
    system: 'System',
    siteMessage: 'Site-in Message',
    // 二级
    // 系统
    organize: 'Organize Manage',
    role: 'Role Manage',
    user: 'User Manage',
    model: 'Model Manage',
    resource: 'Resource Library',
    safe: 'Account Safe',
    security: 'Security Manage',
    storage: 'Storage Manage',
    thirdParty: 'Third-Party Login',
    sms: 'SMS Service',
    email: 'Email Service',
    weixin: 'Weixin Platform',
    firewall: 'Firewall Setting',
    backup: 'Data Backup',
    log: 'Log Manage',
    // 三级
    // 系统
    organizeIndex: 'Organize Manage',
    roleIndex: 'Role Manage',
    userIndex: 'User Manage',
    modelIndex: 'Model Manage',
    resourceIndex: 'Resource Library',
    systemSetting: 'System Setting',
    safeIndex: 'Account Safe',
    securityIndex: 'Security Manage',
    storageIndex: 'Storage Manage',
    thirdPartyIndex: 'Third-Party Login',
    smsIndex: 'SMS Service',
    emailIndex: 'Email Service',
    weixinIndex: 'Weixin Platform',
    firewallIndex: 'Firewall Setting',
    backupIndex: 'Data Backup',
    logIndex: 'Log Manage',
    storageFtpIndex: 'FTP',
    storageCloudIndex: 'Cloud Storage'
  }
}
